// extracted by mini-css-extract-plugin
export default {"sideNav":"sideNav__index__YbKw1","sideNavContent":"sideNavContent__index__eZnbu","logo":"logo__index__rxkVN"};